import { render, staticRenderFns } from "./downloader.vue?vue&type=template&id=2fedc4b2"
import script from "./downloader.vue?vue&type=script&lang=js"
export * from "./downloader.vue?vue&type=script&lang=js"
import style0 from "./downloader.vue?vue&type=style&index=0&id=2fedc4b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports